import React, { useEffect } from 'react'
import { Box, Typography } from '@mui/material'
import OnboardingContainer from 'components/smart/onboarding-container/OnboardingContainer'
import Mail from '../assets/mail.svg'
import { useLocation, useNavigate } from 'react-router-dom'

const WaitingEmailVerification = () => {
  const { state } = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (!state?.email) {
      navigate('/signup')
    }
  }, [])

  return (
    <OnboardingContainer
      srcRightPhoto={Mail}
      bgColorRight="alternate.main"
      topRightPhoto="50%"
      leftRightPhoto="58%"
      heightRightPhoto="57%"
      transformRightPhoto={`translate(${0}%, ${-50}%)`}
    >
      <Box
        height={'100%'}
        display="flex"
        justifyContent={{ xs: 'center', lg: 'flex-end' }}
        alignItems={{ xs: 'center', lg: 'center' }}
      >
        <Box
          width={{ xs: '100%', lg: '500px' }}
          height={{ xs: '90vh', lg: '500px' }}
          mr={{ lg: 7.6875 }}
          p={{ xs: 2 }}
          position={'relative'}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <Box mb={4} display="flex" flexDirection="column" alignItems="center" gap={2}>
            <Typography variant="h2">Verify your email</Typography>
            <Typography variant="body1" textAlign="center" color="light-gray-text.main">
              You’re in! An email has been sent to Hit confirm and you’ll be ready to start working{' '}
              <Typography component="span" fontWeight="bold" color="dark-text.main">
                {state?.email}.{' '}
              </Typography>
              Hit confirm and you’ll be ready to start working.
            </Typography>
          </Box>
        </Box>
      </Box>
    </OnboardingContainer>
  )
}

export default WaitingEmailVerification
